import { ReactNode } from 'react'

import { FooterBox } from './styles'

interface IFooterContainerProps {
  children: ReactNode
}

export function Box({ children }: IFooterContainerProps) {
  return <FooterBox>{children}</FooterBox>
}
